import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import ArrowRightIcon from "@/assets/icons/dominante-arrow-right.svg?react";
import ArrowRightLeftIcon from "@/assets/icons/dominante-arrow-right-left.svg?react";
import InfoCircleIcon from "@/assets/icons/dominante-info-circle.svg?react";
import { Dialog, FormField } from "@/ds";
import { DOMINANTE_DIALOG } from "../../../nova-obra.constants";
import { TagColetor } from "../../../components/tag-coletor";
import styles from "./alterar-dominante-dialog.module.scss";
import { JUSTIFICATIVA_DOMINANTE_MAX } from "./alterar-dominante-dialog.constants";
import type {
  AlterarDominanteDialogProps,
  AlterarDominanteDialogViewModel,
} from "./types-alterar-dominante-dialog";

/** Modal "Alterar tipo de obra dominante" (HU 2528, Figma `modal-dialog` 10446:108002). */
export function AlterarDominanteDialogView(
  props: AlterarDominanteDialogProps & AlterarDominanteDialogViewModel,
) {
  const {
    justificativa,
    alterarJustificativa,
    erro,
    mostrarErro,
    confirmar,
    atual,
    novo,
    onCancel,
  } = props;

  return (
    <Dialog
      visible
      modal
      onHide={onCancel}
      className={styles.dialog}
      headerClassName={styles.header}
      contentClassName={styles.content}
      pt={{ footer: { className: styles.footerRoot } }}
      data-testid="alterar-dominante-dialog"
      aria-label={DOMINANTE_DIALOG.title}
      header={
        <div className={styles.headerLeft}>
          <span className={styles.badge} aria-hidden>
            <ArrowRightLeftIcon />
          </span>
          <div className={styles.headerText}>
            <h2 className={styles.title}>{DOMINANTE_DIALOG.title}</h2>
            <p className={styles.subtitle}>{DOMINANTE_DIALOG.subtitle}</p>
          </div>
        </div>
      }
      footer={
        <div className={styles.footer}>
          {/* Figma 10446:108039: "Voltar" é botão de texto primário (#00425c). */}
          <Button
            type="button"
            text
            label={DOMINANTE_DIALOG.voltar}
            onClick={onCancel}
            className={styles.botao}
          />
          <Button
            type="button"
            label={DOMINANTE_DIALOG.confirmar}
            onClick={confirmar}
            className={styles.botao}
          />
        </div>
      }
    >
      <div className={styles.body}>
        <div className={styles.comparacao}>
          <div className={styles.estado} data-testid="dominante-atual">
            <span className={styles.estadoLabel}>{DOMINANTE_DIALOG.atual}</span>
            <span className={styles.estadoTipo}>
              <TagColetor codigo={atual.codigo} />
              <span className={styles.estadoNome}>{atual.nome}</span>
            </span>
          </div>
          <span className={styles.conector} aria-hidden>
            <ArrowRightIcon />
          </span>
          <div className={styles.estado} data-testid="dominante-novo">
            <span className={styles.estadoLabel}>{DOMINANTE_DIALOG.novo}</span>
            <span className={styles.estadoTipo}>
              <TagColetor codigo={novo.codigo} />
              <span className={styles.estadoNome}>{novo.nome}</span>
            </span>
          </div>
        </div>

        <div className={styles.aviso}>
          <InfoCircleIcon aria-hidden />
          <p>{DOMINANTE_DIALOG.aviso}</p>
        </div>

        <FormField.Root className={styles.campo} error={mostrarErro ? erro : null}>
          <div className={styles.campoCabecalho}>
            <FormField.Label>{DOMINANTE_DIALOG.justificativa}</FormField.Label>
            <span className={styles.obrigatorio}>{DOMINANTE_DIALOG.obrigatorio}</span>
          </div>
          <FormField.Control>
            <InputTextarea
              value={justificativa}
              maxLength={JUSTIFICATIVA_DOMINANTE_MAX}
              rows={2}
              aria-required
              onChange={(event) => alterarJustificativa(event.target.value)}
              className={styles.textarea}
            />
          </FormField.Control>
          <FormField.Error />
        </FormField.Root>
      </div>
    </Dialog>
  );
}
